


import React from "react";
import "./paramedical.css";
import img from "../paramedicalcareer/germany.png";
import InquiryForm from "../InquiryForm";

const ParamedicalCareerGermany = () => {
  return (
    <div className="career-container">
      <h1 className="career-title">Paramedical Career in Germany</h1>

      {/* Overview */}
      <div className="career-card animate-fade">
        <h2>Overview</h2>
        <p>
          Germany is experiencing a massive healthcare staff shortage, offering
          abundant paramedical career opportunities for international candidates.
          Roles like paramedics (<b>Notfallsanitäter</b>), medical technicians
          (Radiology/Laboratory), and physiotherapists are in high demand, with
          average annual salaries ranging from <b>€35,000 to €50,000</b> (INR
          31–45 Lakh) depending on experience.
        </p>
      </div>

      {/* Career Paths */}
      <div className="career-card animate-slide">
        <h2>Career Pathways</h2>
        <p>
          International candidates can build a paramedical career in Germany
          through two primary paths: <b>vocational training</b> or{" "}
          <b>professional recognition (Anerkennung)</b>.
        </p>
      </div>

      {/* ✅ Local germany.png — centered, full width, styled */}
      <div className="career-img">
        <img src={img} alt="Germany Paramedical" />
      </div>

      {/* Qualification Recognition */}
      <div className="career-card animate-fade">
        <h2>Qualification Recognition (Anerkennung)</h2>
        <p>
          If you already hold a paramedical degree or diploma from your home
          country, you must have it officially recognized as equivalent to
          German standards.
        </p>
        <ul>
          <li>
            <b>Regulatory Check:</b> Recognition is handled by regional
            authorities (Regierungspräsidium or state health ministries).
          </li>
          <li>
            <b>Required Documents:</b> Certified translations of degree
            certificates, academic transcripts, a clean police clearance
            certificate, and a medical fitness certificate.
          </li>
          <li>
            <b>Adaptation Period:</b> If your training doesn't match the German
            curriculum, you may need to complete an adaptation period or pass a
            knowledge test (<b>Kenntnisprüfung</b>).
          </li>
        </ul>
      </div>

      {/* Why Germany */}
      <div className="career-card animate-slide">
        <h2>Why Germany is Best for Paramedical Field</h2>
        <ul>
          <li>Huge shortage of healthcare workers</li>
          <li>No IELTS required (in many cases)</li>
          <li>Free or low-cost education</li>
          <li>Earn while you learn options</li>
          <li>Direct Permanent Residency pathway</li>
        </ul>
      </div>

      <InquiryForm title="Inquire About Germany Programs" />
        <div className="back-home-wrapper">
  <button className="back-home-btn" onClick={() => window.location.href = "/"}>
    ← Go Back to Home
  </button>
</div>
    </div>
  );
};

export default ParamedicalCareerGermany;